import operandType from '../../../../infrastructure/constants/functions/operandType';
import SelectOption from '../../../../infrastructure/types/SelectOption';

const leiResultSetOptions: SelectOption[] = [
    { text: 'LEVEL-1', value: operandType.leiResultSetLevel1 }
];

export { leiResultSetOptions };
